/**
 * The login constants module houses login-specific configurations.
 *
 * @module routes.login.constants
 */

angular.module('routes.login.constants', [])
  .config([
    '$provide',
    function ($provide) {
      'use strict';

      // Define.
      var login;

      // Set defaults.
      login = {};

      /**
       * Defines login constants.
       *
       * @attribute LOGIN
       * @type String
       * @readOnly
       */
      $provide.constant('LOGIN', login);
    }
  ]);
